import { instance } from "api/apiBase";
import { AxiosError } from "axios";

interface SentriLockStatusResponse {
  connected: boolean;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/sentrilock";

const handleSentriLockError = (error: unknown): never => {
  const axiosError = error as AxiosError;
  if (axiosError.response?.status === 422)
    throw new Error(
      "Connection failed. Please check your credentials and try again."
    );
  throw error;
};

export const sentriLockApi = {
  getStatus: async (): Promise<SentriLockStatusResponse> => {
    const { data } =
      await instance.get<SentriLockStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (payload: {
    username: string;
    password: string;
  }): Promise<SentriLockStatusResponse> => {
    try {
      const { data } = await instance.post<SentriLockStatusResponse>(
        BASE_ENDPOINT_URL,
        payload
      );
      return data;
    } catch (error) {
      return handleSentriLockError(error);
    }
  },

  disconnect: async (): Promise<SentriLockStatusResponse> => {
    const { data } =
      await instance.delete<SentriLockStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  }
};
